import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useEffect } from "react"
import { ShowJustifyEditButton, TaskEditJustification } from "event-definitions"
import { If } from "lib/@components/switch"
import { JustifyChanges } from "./justify-changes"
import { DisplayJustification } from "./display-justification"

export function ScheduleEditJustification() {
    const {
        hasChanged,
        editMode,
        item,
        isDialogVisible,
        setIsDialogVisible,
        latestReason,
        loading,
        setIsEdit,
        taskId,
        isNewTask,
    } = useBoundContext()

    useEffect(() => {
        let isActive = false
        let overrideTip = false
        if (!isDialogVisible && (hasChanged || isNewTask) && editMode && !latestReason && !loading) {
            isActive = true
        }
        if (editMode && !loading && (hasChanged || isNewTask) && (latestReason || isDialogVisible)) {
            overrideTip = true
        }
        ShowJustifyEditButton.raise({ taskId, isActive, overrideTip, hasChanged, isNewTask })
    }, [editMode, hasChanged, isDialogVisible, latestReason, loading, taskId, isNewTask])

    TaskEditJustification.useEvent(({ taskId }) => {
        if (taskId !== item.taskId) return
        setIsEdit(false)
        setIsDialogVisible(true)
    })

    return (
        <>
            <If truthy={isDialogVisible && (hasChanged || isNewTask)}>
                <JustifyChanges />
            </If>
            <If truthy={!isDialogVisible && (hasChanged || isNewTask) && !!latestReason}>
                <DisplayJustification showReasonDialog={() => setIsDialogVisible(true)} />
            </If>
        </>
    )
}
